import React, { useState, useEffect } from "react";

import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";

import {
  NavigationImpressum,
} from "../components/navigationimpressum";
import { Footer } from "../components/footer";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Impressum = () => {
  //https://react-landing-page-template-93ne.vercel.app/
  //https://github.com/issaafalkattan/React-Landing-Page-Template
  

  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <NavigationImpressum />
      <div>
        <br />
      </div>
      <div id="impressum">
        <div className="container">
          <section>
            <div className="container">
              <div className="section-title">
                <h2>Impressum</h2>
              </div>
              <div id="row">
                <h3>Die Containerklinik</h3>
                <p>
                  <b>Strasse:</b> {landingPageData.Contact ? landingPageData.Contact.street: "Lädt..."}
                  <br />
                  <b>PLZ / Ort:</b> {landingPageData.Contact ? landingPageData.Contact.zipcode: "Lädt..."} / {landingPageData.Contact ? landingPageData.Contact.city: "Lädt..."}
                  <br />
                  <b>Land:</b> {landingPageData.Contact ? landingPageData.Contact.country: "Lädt..."}
                </p>

                <h3>Kontakt</h3>
                <p>
                <b>Geschäftsführung:</b> {landingPageData.Contact ? landingPageData.Contact.ceo: "Lädt..."}
                <br />
                  <b>Telefon:</b> {landingPageData.Contact ? landingPageData.Contact.phone: "Lädt..."}
                  <br />
                  <b>E-Mail:</b> {landingPageData.Contact ? landingPageData.Contact.email: "Lädt..."}
                 
                </p>

                <h3>Rechtliches</h3>
                <p>
                  <b>UStID:</b> {landingPageData.Contact ? landingPageData.Contact.ustid: "Lädt..."}
                  <br />
                  {
                 //  Die Containerklinik ist eingetragen im Handelsregister beim
                  // {landingPageData.Contact ? landingPageData.Contact.handelsregister: "Lädt..."}.
                  // <br />
                  }
                  V.I.S.D.P. {landingPageData.Contact ? landingPageData.Contact.ceo: "Lädt..."}
                </p>


                <h3>Disclaimer</h3>
                <p>
                  Mit Urteil vom 12. Mai 1998 hat das Landgericht Hamburg
                  entschieden, dass man durch die Anbringung eines Links die
                  Inhalte der gelinkten Seite ggf. mit zu verantworten hat. Dies
                  kann - so das Landgericht - nur dadurch vermieden werden, dass
                  man sich ausdrücklich von diesen Inhalten distanziert. Wir
                  haben auf unserer Seite Links zu anderen Seiten im Internet
                  gelegt. Für all diese Links gilt: Wir möchten ausdrücklich
                  betonen, dass wir keinerlei Einfluss auf die Gestaltung und
                  die Inhalte der gelinkten Seiten haben. Deshalb distanzieren
                  wir uns hiermit ausdrücklich von allen Inhalten aller
                  gelinkten Seiten auf www.diecontainerklinik.de und wir machen uns deren
                  Inhalte nicht zu Eigen. Diese Erklärung gilt für alle auf
                  unserer Seite angebrachten Links und für alle Inhalte der
                  Seiten, zu denen die Banner führen.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Impressum;
